import React, { ReactNode } from 'react';
import { Typography } from '../../../../../../wag-react/components/Typography';
import { BoxProps } from '../../../../../../wag-react/next-components/box';
import { Flex } from '../../../../../../wag-react/next-components/Flex';
import { QuestionFilledIcon } from '../../../../../../wag-react/next-components/icons';
export type BenefitAddOnV2Props = {
  description: ReactNode;
  name: string;
  onHelpIconClick: (name: string, description: ReactNode) => void;
} & BoxProps;
export const BenefitAddOnV2 = ({
  description,
  name,
  onHelpIconClick,
  ...rest
}: BenefitAddOnV2Props) => <Flex alignItems="center" border="2px solid #e5e5e5" borderRadius="8px" cursor="pointer" justifyContent="space-between" height={['56px', 'null', '65px']} px={['12px', null, '28px']} mx={['unset', '14px']} onClick={() => {
  onHelpIconClick(name, description);
}} {...rest} data-sentry-element="Flex" data-sentry-component="BenefitAddOnV2" data-sentry-source-file="index.tsx">
    <Typography fontFamily="muliBold" data-sentry-element="Typography" data-sentry-source-file="index.tsx">
      {name}
    </Typography>

    <Flex alignItems="center" data-sentry-element="Flex" data-sentry-source-file="index.tsx">

      <QuestionFilledIcon color="#d8d8d8" cursor="pointer" height="22px" ml={['8px', null, '20px']} width="22px" data-sentry-element="QuestionFilledIcon" data-sentry-source-file="index.tsx" />
    </Flex>
  </Flex>;